import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection, InspectionPlugin, Icons } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';
import { CommentPluginService } from './comment-plugin.service';

@Component({
    templateUrl: './comment.component.html',
    standalone: false
})
export class CommentPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public inspection: Inspection;
  public remarks: any;

  constructor(
    public commentService: CommentPluginService,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.remarks = this.plugin.config.Remarks;
    this.cdRef.detectChanges();
  }

  initData() {}

  getEditRoute() {
    return [
      this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId ? this.plugin.pointId : -1,
      'plugins',
      this.plugin.id,
      'comment',
      'edit'
    ];
  }
}

PluginComponent.plugins['comment'] = CommentPluginComponent;
PluginComponent.initializers['comment'] = (plugin: InspectionPlugin) => {
  if (plugin.config && plugin.config.Remarks && plugin.config.Remarks.some((r) => r.Type === 1 || r.Type === 2)) {
    const point = plugin.inspection.pointsById[plugin.pointId];
    if (point) {
      Icons.initIcon(point, Icons.getIconByName(Icons.commentsIconName));
    }
    plugin.config.Remarks.forEach((r) => {
      if (r.Icon) {
        Icons.initIcon(point, Icons.getIconByName(`${Icons.importantIcon}${r.Icon}`));
      }
    });
  }
};
